/* globals addQueryParam, chartProperties, dateMidpoint, getTimeRange */
(function () {
	'use strict';
	angular.module('widgets.buyer')
		.directive('directiveGenericBuyerWidget', directiveGenericBuyerWidget);
	function directiveGenericBuyerWidget($filter, $window, $timeout, $rootScope, $state,
			currencyFormatService, numberFormatService, percentageFormatService, integerFormatService,
			$translate, formatterService, WEEKLY_LOG_ITEM_FIELDS, buyerStdCurrentShortagesService, shortageCriticalityLevelService, drilldownFunctionsService,
			weeklyDiffService) {

		// current services that are being used, will need to add them to this object if we add more
		var services = {
			'currencyFormatService': currencyFormatService,
			'numberFormatService': numberFormatService,
			'integerFormatService': integerFormatService,
			'percentageFormatService': percentageFormatService
		};

		//code from directiveFn1
		return {
			restrict: 'EA',
			scope: {
				chartId: '@chartId'
			}, //chartId passed in from controller via HTML
			link: function (scope, elem, attrs) {
				var chart;
				var generateListener;
				elem[0].id = elem[0].id + scope.$id;
				var scopeAccessor = scope.$parent.$parent;
				var widgetHeight = 100;
				var numAxisTicks = 3;
				var slideshow = false;
				scope.paddingTop = 4;
				var w = angular.element($window);
				var width = Math.max(w.width(), window.innerWidth);
				var RANK_FOR_NONE = shortageCriticalityLevelService.rankForNone;
				scope.height = window.innerHeight;
				if (jQuery(elem[0]).parents('.slideshowWidget').length) {
					widgetHeight = scope.height - 130 - 95;
					numAxisTicks = 5;
					//change bgNum container height
					var parent = jQuery(elem[0]).parent();
					scope.paddingLeft = 75;
					scope.paddingTop = 8;
					slideshow = true;
				}

				//get the window width to help with responsiveness

				if (width > 992) {
					scope.paddingRight = 22;
					scope.paddingLeft = slideshow ? 75 : 59;
				} else if (width >= 768) {
					scope.paddingRight = 17.6;
					scope.paddingLeft = slideshow ? 75 : 48;
				} else {
					scope.paddingRight = 13.2;
					scope.paddingLeft = slideshow ? 75 : 36;
				}

				scope.getWindowDimensions = function () {
					return {
						'w': Math.max(w.width(), window.innerWidth),
						'h': window.innerHeight
					};
				};

				scope.$watch(scope.getWindowDimensions, function (newValue, oldValue) {
					scope.windowWidth = newValue.w;
					scope.height = newValue.h;
					var currentPaddingLeft = scope.paddingLeft;
					if (scope.windowWidth >= 992) {
						scope.paddingRight = 22;
						scope.paddingLeft = slideshow ? 75 : 59;
					} else if (scope.windowWidth >= 768) {
						scope.paddingRight = 17.6;
						scope.paddingLeft = slideshow ? 75 : 48;
					} else {
						scope.paddingRight = 13.2;
						scope.paddingLeft = slideshow ? 75 : 36;
					}

					if (currentPaddingLeft !== scope.paddingLeft || slideshow) {
						generateChart();
					}
				}, true);

				w.bind('resize', function () {
					scope.$apply();
				});

				//reading in the chart properties for this chart
				var chartKey = scope.chartId;
				var eventName = chartProperties[chartKey].eventName;
				var xAxisField = chartProperties[chartKey].xAxisField;
				var xAxisInterval = chartProperties[chartKey].xAxisInterval;
				var yAxisFieldKey = chartProperties[chartKey].yAxisFieldKey;
				if (typeof yAxisFieldKey === 'function' && scope.$parent && scope.$parent.$parent) {
					yAxisFieldKey = yAxisFieldKey(scope.$parent.$parent.settings);
				}
				var yAxisFieldName = chartProperties[chartKey].yAxisFieldName;
				if (typeof yAxisFieldName === 'function' && scope.$parent && scope.$parent.$parent) {
					yAxisFieldName = yAxisFieldName(scope.$parent.$parent.settings);
				}
				var yAxisFieldLabel = chartProperties[chartKey].yAxisFieldLabel;
				var fmtService = services[chartProperties[chartKey].fmtService];
				var currentYAxisNameSettings = _.cloneDeep(scope.$parent.$parent.settings);
				if (yAxisFieldName) {
					$translate(yAxisFieldName).then(function (tt) {
						yAxisFieldName = tt;
					});
				}
				var xTicks = {};

				var yMax;
				var yMin;

				function getYMaxAndMin(curMin, curMax, numTicks, integer) {
					var multiple = numTicks - 1;
					yMax = curMax;
					yMin = curMin;
					yMin = yMin * 0.95;
					yMax = yMax * 1.05;
					if (integer) {
						yMin = Math.floor(yMin);
						yMax = Math.ceil(yMax);
						var diff = yMax - yMin;
						var newDiff = Math.ceil(diff / multiple) * multiple;
						yMax = yMin + newDiff;
					}
				}
				var criticalityLvlColors = {};
				var inactiveLabels = {};
				function getCriticalityLvlBreakDown(chartData, axisField, criticalityLvlRanks) {
					var groups = [];
					var lvls = {};
					var primaryColors = {
						'p0': '#c30015',
						'p1': '#f42f2f',
						'p2': '#ff9b30',
						'p3': '#f4ce00',
						'p4': '#7cc4fa',
						'inactive': '#8F8F92'
					};

					angular.forEach(chartData, function (data) {
						if (data[axisField]) {
							var criticalityLvlData = JSON.parse(data[axisField]);
							if (criticalityLvlData && _.isObject(criticalityLvlData)) {
								_.each(criticalityLvlData, function (value, key) {
									var dataKey = key === 'None' ? 'Non Critical' : key;
									data[dataKey] = value;
									if (lvls[dataKey] === undefined) {
										groups.push({
											'label': dataKey,
											'rank': criticalityLvlRanks && criticalityLvlRanks[dataKey] ? criticalityLvlRanks[dataKey].rank : RANK_FOR_NONE,
											'active': criticalityLvlRanks[dataKey] ? criticalityLvlRanks[dataKey].active : 1
										});
									}
									lvls[dataKey] = true;
								});
							}

						}
					});
					return _.orderBy(groups, ['rank']).map(function(group, index) {
						var color = primaryColors['p' + index] && group.rank !== RANK_FOR_NONE ? primaryColors['p' + index] : group.rank === RANK_FOR_NONE ? '#b6e4ff' : '#7cc4fa';
						if (!group.active) {
							color = primaryColors.inactive;
							inactiveLabels[group.label] = true;
						}
						criticalityLvlColors[group.label] = color;
						return group.label;
					});
				}

				function criticalityBreakdownTooltipContent(d, defaultTitleFormat, defaultValueFormat, color) {
					var $$ = this,
						config = $$.config,
						CLASS = $$.CLASS,
						titleFormat = config.tooltip_format_title || defaultTitleFormat,
						nameFormat = config.tooltip_format_name || function (name) {
							return name;
						},
						valueFormat = config.tooltip_format_value || defaultValueFormat,
						text, i, title, value, name;
					for (i = 0; i < d.length; i++) {
						if (!(d[i] && (d[i].value || d[i].value === 0))) {
							continue;
						}

						if (!d[i].value && inactiveLabels[d[i].name]) {
							continue;
						}

						if (!text) {
							title = titleFormat ? titleFormat(d[i].x) : d[i].x;
							text = "<table class='" + CLASS.tooltip + "'>" + (title || title === 0 ? "<tr><th colspan='2'>" + title + '</th></tr>' : '');
						}

						value = valueFormat(d[i].value, d[i].ratio, d[i].id, d[i].index);
						name = nameFormat(d[i].name) + (inactiveLabels[d[i].name] ? ' (inactive)' : '');
						var groupColor = criticalityLvlColors[d[i].name];
						var additionalStyle = inactiveLabels[d[i].name] ? ';font-style: italic' : '';
						if (value !== undefined) {
							text += "<tr class='" + CLASS.tooltipName + '-' + d[i].id + "'>";
							text += "<td class='name' style='" + additionalStyle + "'><span style='background-color:" + groupColor + "'></span>" + name + '</td>';
							text += "<td class='value'>" + value + '</td>';
							text += '</tr>';
						}
					}
					return text + '</table>';
				}

				var data;
				var generateChart = function () {
					yAxisFieldKey = chartProperties[chartKey].yAxisFieldKey;
					var settings = scopeAccessor.settings;
					if (Array.isArray(yAxisFieldKey)) {
						yAxisFieldKey = yAxisFieldKey[0];
					} else if (typeof yAxisFieldKey === 'function') {
						yAxisFieldKey = yAxisFieldKey(settings);
					}
					data = scopeAccessor.chartData;
					var currency = scopeAccessor.currency;
					var groups = undefined;
					var criticalityLvlRanks = scopeAccessor.criticalityLvlRanks;
					var dateList = undefined;

					if (!data) {
						return;
					}

					if (settings && settings.breakdown) {
						if (scopeAccessor.isShortages) {
							if (scopeAccessor.showCriticalityBreakDown && settings.breakdown === 'None') {
								var criticalityLvlField = WEEKLY_LOG_ITEM_FIELDS[chartKey].filter(function (field) {
									return !!field.criticalityLvlField;
								}).map(function (field) {
									return field.criticalityLvlField + (field.type === 'Manufactured' ? 'Manufactured' : '');
								})[0];
								groups = getCriticalityLvlBreakDown(data, criticalityLvlField, criticalityLvlRanks);
								dateList = [];
								angular.forEach(data, function (dp) {
									dateList.push($filter('date')(dp[xAxisField], 'MMM dd', 'UTC'));
								});
							} else if (settings.breakdown === 'None') {

							}
						}
					}

					if (currency && currency.length >= 3) {
						scope.paddingLeft += 20;
					}

					var xGridLines = [];
					angular.forEach(data, function (d) {
						d[xAxisField] = new Date(d[xAxisField]);
					});
					if (scopeAccessor.delta) {
						//this is being used for the graphs with daily data points rather than weekly
						scope.$parent.diff = scopeAccessor.delta;
					} else {
						var diff = {};
						var delta = 0;

						// calculate diff from data
						if (data.length > 1) {
							if (xAxisInterval === 'weekly' ) {
								diff = weeklyDiffService.getDataPoints(data);
								delta = diff.lastDataPoint[yAxisFieldKey] - diff.previousDataPoint[yAxisFieldKey];
							} else if (xAxisInterval === 'daily') {
								// currently there are no daily widgets
								if (data.length >= 7) {
									delta = data[data.length - 1][yAxisFieldKey] - data[data.length - 7][yAxisFieldKey];
								}
							}
							var isBadFlipped = settings.doiCalculation && settings.doiCalculationTurnsOrDays === 'Turns' || chartProperties[chartKey].isBadFlipped === true;
							scope.$parent.diff = {
								delta: delta,
								status: (isBadFlipped ? delta < 0 : delta > 0) ? 'bad' : 'good',
								addnlLabelText: weeklyDiffService.getAdditionalLabelText(diff.previousDataPoint)
							};

							//format the diff
							var formattedDiff = {};
							formattedDiff.delta = scope.$parent.diff.delta;

							// getWithParameters has different parameters depending on the service
							if (chartProperties[chartKey].fmtService === 'numberFormatService' || chartProperties[chartKey].fmtService === 'integerFormatService') {
								formattedDiff.delta = fmtService.getWithParameters(formattedDiff.delta, formatterService.numberOfDecimals(formattedDiff.delta), true);
								if (formattedDiff.delta === '-0.00' || formattedDiff.delta === '0.00') {
									formattedDiff.delta = '0';
									diff.delta = 0;
								}
								if (formattedDiff.delta.endsWith('.00')) {
									formattedDiff.delta = formattedDiff.delta.substring(0, formattedDiff.delta.length - 3);
								}
							} else {
								formattedDiff.delta = fmtService.getWithParameters(formattedDiff.delta, 0, currency);
							}

							scope.$parent.formattedDiff = formattedDiff;
							scope.$parent.formattedDiff.addnlLabelText = scope.$parent.diff.addnlLabelText;
						}
					}

					// gridlines
					if (data.length >= 2) {
						var middle = dateMidpoint(data[0][xAxisField], data[data.length - 1][xAxisField]);
						var middle2 = dateMidpoint(data[0][xAxisField], middle);
						var middle3 = dateMidpoint(data[data.length - 1][xAxisField], middle);
						xGridLines = [{
							value: data[0][xAxisField]
						}, {
							value: data[data.length - 1][xAxisField]
						},
						{
							value: middle
						}, {
							value: middle2
						}, {
							value: middle3
						}
						];
					}

					var min = 0;
					var max = 0;
					if (chartProperties[chartKey].yAxisMinAndMax) {
						yMin = chartProperties[chartKey].yAxisMinAndMax.yMin;
						yMax = chartProperties[chartKey].yAxisMinAndMax.yMax;
					} else {
						if (data.length) {
							min = data[0][yAxisFieldKey];
							max = data[0][yAxisFieldKey];
							for (var i = 0; i < data.length; i++) {
								if (!data[i][yAxisFieldKey] && data[i][yAxisFieldKey !== 0]) {
									continue;
								}
								if (data[i][yAxisFieldKey] < min || (!min && min !== 0)) {
									min = data[i][yAxisFieldKey];
								}
								if (data[i][yAxisFieldKey] > max) {
									max = data[i][yAxisFieldKey];
								}
							}
						}
						getYMaxAndMin(min, max, numAxisTicks,
							chartProperties[chartKey].fmtService === 'integerFormatService');
					}

					var formattedMaxValue = fmtService.get(yMax, currency);
					if (formattedMaxValue && formattedMaxValue.length >= 5) {
						scope.paddingLeft += (formattedMaxValue.length - 4) * 3;
					}

					var config = {};
					var timeRange = getTimeRange(data, xAxisField);
					config.bindto = '#' + elem[0].id;
					config.data = {};
					config.data.keys = {
						value: (
							Array.isArray(chartProperties[chartKey].yAxisFieldKey)
								? chartProperties[chartKey].yAxisFieldKey
								: [
									typeof yAxisFieldKey === 'function'
										? yAxisFieldKey(settings)
										: yAxisFieldKey
								]
						)
					};

					config.point = {
						r: 0.5,
						focus: {
							expand: {
								r: 3.5
							}
						}
					};
					config.data.json = data;
					config.data.type = groups ? 'bar' : 'area';
					if (groups) {
						config.data.keys.value = groups;
						config.data.groups = [groups];
						config.data.colors = criticalityLvlColors;
						config.data.order = null;
					} else {
						config.data.keys.x =  xAxisField;
						config.data.color = function (color, d) {
							return '#0584E2';
						};
					}

					config.padding = {
						right: scope.paddingRight,
						left: scope.paddingLeft,
						top: scope.paddingTop
					};
					config.axis = {};
					if (!groups) {
						config.axis.x = {
							'type': 'timeseries',
							localtime: false,
							padding: {
								left: 0,
								right: timeRange / 325
							},
							tick: {
								format: function (x) {
									return $filter('date')(x, 'MMM dd', 'UTC');
								},
								count: 5,
								outer: false,
								multiline: false
							}
						};
					} else {
						config.axis.x = {
							type: 'category',
							categories: dateList,
							tick: {
								count: 5,
								outer: false,
								multiline: false
							}
						};
					}

					config.axis.y = {
						tick: {
							format: function (x) {
								return fmtService.get(x, currency);
							},
							count: numAxisTicks
						},
						min: groups ? 0: yMin,
						max: yMax,
						padding: {
							bottom: 0,
							top: 0
						}
					};
					config.size = {};
					config.size.height = widgetHeight + (groups && !slideshow ? 100 : 0);
					config.data.names = {
						yAxisFieldName: yAxisFieldLabel
					};
					config.legend = {};
					config.legend.show = false;
					config.grid = {
						x: {
							lines: xGridLines
						},
						y: {
							show: true
						}
					};
					if (!groups) {
						config.tooltip = {
							format: {
								name: function (value, ratio, id) {
									if (!_.isEqual(currentYAxisNameSettings, scope.$parent.$parent.settings)) {
										yAxisFieldName = chartProperties[chartKey].yAxisFieldName;
										if (typeof yAxisFieldName === 'function' && scope.$parent && scope.$parent.$parent) {
											yAxisFieldName = yAxisFieldName(scope.$parent.$parent.settings);
										}
										$translate(yAxisFieldName).then(function (tt) {
											yAxisFieldName = tt;
										});
										currentYAxisNameSettings = _.cloneDeep(scope.$parent.$parent.settings);
									}
									return yAxisFieldName;
								}
							}
						};
					} else {
						config.legend.show = true;
						var startTimestamp = (data && data.length) ? data[0][xAxisField] : 0;
						var endTimestamp = (data && data.length) ? data[data.length - 1][xAxisField] : 0;
						// one day
						var interval = 7 * 60 * 60 * 24 * 1000;

						var possiblePoints = Math.ceil((endTimestamp - startTimestamp) / interval) + 1;
						var chartWidth = jQuery('#' + elem[0].id).width() - scope.paddingLeft - scope.paddingRight;
						var barWidth = chartWidth / possiblePoints;
						config.bar = {
							width: barWidth * 0.5
						};
						config.tooltip = {
							contents: criticalityBreakdownTooltipContent
						};
					}

					if (scopeAccessor.isShortages && scopeAccessor.settings.breakdown === 'None' && 
						scopeAccessor.showCriticalityBreakDown) {
						config.legend.hide = _.filter(criticalityLvlRanks, function (lvl) {
							return !lvl.active;
						}).map(function (lvl) {
							return lvl.label;
						});
						config.legend.item = {
							onclick: function (id) {
								chart.toggle(id);
								var selectedKeys = [];
								// update bgnum and delta
								var visibleValue = 0.0;
								var i;

								var lastPoint = config.data.json[config.data.json.length - 1];
								var visibleData = scope.chart.data.shown();
								for (i = 0; i < visibleData.length; i++) {
									visibleValue += lastPoint[visibleData[i].id];
									selectedKeys.push(visibleData[i].id);
								}

								$timeout(function () {
									scopeAccessor.formattedBgNum.value = fmtService.getWithParameters(
										visibleValue, 0, scope.currency);
								});

								scope.deltaValue = 0;
								
								if (config.data.json.length > 1) {
									var weeksBack = config.data.json.length >= 3 ? 3 : 2;
									var previousPoint = config.data.json[config.data.json.length - weeksBack];

									var previousValue = 0.0;
									for (i = 0; i < visibleData.length; i++) {
										previousValue += previousPoint[visibleData[i].id];
									}
									scope.deltaValue = visibleValue - previousValue;
									$timeout(function () {
										diff.delta = _.clone(scope.deltaValue);
										var isBadFlipped = settings.doiCalculation && settings.doiCalculationTurnsOrDays === 'Turns' || chartProperties[chartKey].isBadFlipped === true;
										diff.status = (isBadFlipped ? diff.delta < 0 : diff.delta > 0) ? 'bad' : 'good';
										scope.$parent.diff = diff;
										scope.$parent.formattedDiff.delta = fmtService.getWithParameters(
											scope.deltaValue, 0, scope.currency);
									});
								}

								var url = decodeURIComponent(scope.$parent.content.drillDownUrl);
								var params = parseQueryString(url);
								var baseUrl = url.split('?')[0];
								// clear out existing date creation query params
								delete params.shortageCriticalityLevel;
								if (selectedKeys.length != groups.length) {
									var criticalityLvlIds = [];
									angular.forEach(selectedKeys, function(key) {
										if (scopeAccessor.criticalityLvlRanks[key]) {
											criticalityLvlIds.push(scopeAccessor.criticalityLvlRanks[key].id);
										} else {
											criticalityLvlIds.push('-1');
										}
									});
									params['shortageCriticalityLevel'] = criticalityLvlIds;
								}
								scope.$parent.content.drillDownUrl = addQueryParam(baseUrl, null, params, false);
							}
						};
					}

					config.onrendered = function () {
						jQuery('#' + elem.attr('id') + ' .c3-xgrid-lines').prependTo(
							jQuery('#' + elem.attr('id') + ' .c3-grid').first());
					};
					if (typeof chartProperties[chartKey].graphConfig === 'function') {

						if (scopeAccessor.isShortages) {
							if (scopeAccessor.settings.breakdown !== 'None') {
								config = chartProperties[chartKey].graphConfig(scopeAccessor, $rootScope, $window.innerHeight, elem, buyerStdCurrentShortagesService, $state, drilldownFunctionsService);
							}
						} else {
							config = chartProperties[chartKey].graphConfig(config, scope, $translate, fmtService, $timeout, weeklyDiffService);
						}
					}
					chart = c3.generate(config);
					scope.chart = chart;
				};
				generateListener = scope.$on(eventName, function () {
					generateChart();
				});

				scope.$on('$destroy', function () {
					if (chart) {
						chart.destroy();
					}
					if (generateListener) {
						generateListener();
					}
				});
			}
		};
	}
})();
